// import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Percomatic } from '@biggby-coffee/percomatic-typescript';

import { Option } from '../../../components/Option';
import { activeModifierGroupState, modifyingState } from '../../atoms';
import { useDeselectModifier, useSelectModifier } from '../../hooks/api';
import { ModifierButton } from '../ModifierButton';

export type ModifierGroupProps = {
	modifierGroupIndex: number;
	isActive: boolean;
	modifierGroup: Percomatic.Serialized.ModifierGroup;
	modifierModel: Percomatic.Serialized.ModifierModel;
};

export const ModifierGroup: React.FC<ModifierGroupProps> = ({
	modifierGroupIndex,
	isActive,
	modifierGroup,
	modifierModel
}) => {
	const modifying = useRecoilValue(modifyingState);
	const setActiveModifierGroup = useSetRecoilState(activeModifierGroupState);
	const selectModifier = useSelectModifier();
	const deselectModifier = useDeselectModifier();

	const buttonClickHandler =
		(modifierIndex: number): (() => void) =>
		() => {
			if (modifying || !isActive) {
				return;
			}

			if (modifierModel.modifiersAreSelected[modifierIndex]) {
				return deselectModifier(modifierGroupIndex, modifierIndex);
			}

			selectModifier(modifierGroupIndex, modifierIndex);
		};

	const groupSelected = modifierModel.modifiers
		.filter((_, index) => modifierModel.modifiersAreSelected[index])
		.map(({ name }) => name);

	return (
		<div className="product-modifier-group">
			<Option
				isActive={isActive}
				header={{
					name: modifierGroup.name,
					left: modifierGroup.name,
					right: groupSelected.join(', '),
					onClick() {
						if (isActive) {
							return setActiveModifierGroup(-1);
						}

						setActiveModifierGroup(modifierGroupIndex);
					}
				}}
			>
				<div className="grid-250-gap-15-p0 modifier-group-buttons">
					{modifierModel.modifiers.map((mod, index) => (
						<ModifierButton
							key={index}
							modifier={mod}
							modifierGroupIndex={modifierGroupIndex}
							modifierIndex={index}
							buttonClickHandler={buttonClickHandler}
							isActive={modifierModel.modifiersAreSelected[index]}
						/>
					))}
				</div>
			</Option>
		</div>
	);
};
